export type AddressType = {
  street?: string;
  civic?: string;
  city?: string;
  postalCode?: string;
  province?: string;
  country?: string;
};

export const toFullAddress = (address?: AddressType) => {
  if (address === undefined || address === null) return "";

  const street = address.street ? `${address.street} ` : "";
  const civic = address.civic ? `${address.civic} ` : "";
  const city = address.city ? `${address.city} ` : "";
  const postalCode = address.postalCode ? `${address.postalCode} ` : "";
  const province = address.province ? `${address.province} ` : "";
  const country = address.country ? `${address.country} ` : "";

  return `${street}${civic}${city}${postalCode}${province}${country}`;
};
